var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-pix"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5996 22.0264L16.5862 18.0131C16.4396 17.8664 16.2662 17.8397 16.1729 17.8397C16.0796 17.8397 15.9062 17.8664 15.7596 18.0131L11.7329 22.0397C11.2796 22.4931 10.5729 23.2264 8.21289 23.2264L13.1596 28.1597C13.9096 28.9088 14.9262 29.3295 15.9862 29.3295C17.0462 29.3295 18.0629 28.9088 18.8129 28.1597L23.7729 23.2131C22.5596 23.2131 21.5462 22.9731 20.5996 22.0264ZM11.7329 9.95974L15.7596 13.9864C15.8662 14.0931 16.0262 14.1597 16.1729 14.1597C16.3196 14.1597 16.4796 14.0931 16.5862 13.9864L20.5729 9.99974C21.5196 9.01307 22.5996 8.7864 23.8129 8.7864L18.8529 3.83974C18.1029 3.09067 17.0862 2.66992 16.0262 2.66992C14.9662 2.66992 13.9496 3.09067 13.1996 3.83974L8.25289 8.77307C10.5996 8.77307 11.3196 9.5464 11.7329 9.95974Z",
    fill: "#37B4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.1464 13.1338L25.1464 10.1204H23.4664C22.7464 10.1204 22.0264 10.4137 21.5331 10.9337L17.5331 14.9337C17.1597 15.3071 16.6664 15.4937 16.1731 15.4937C15.6651 15.4866 15.1788 15.2864 14.8131 14.9337L10.7864 10.8937C10.2797 10.3871 9.5864 10.0938 8.85307 10.0938H6.89307L3.83974 13.1604C3.09067 13.9104 2.66992 14.9271 2.66992 15.9871C2.66992 17.0471 3.09067 18.0637 3.83974 18.8137L6.89307 21.8804H8.8664C9.5864 21.8804 10.2797 21.5871 10.7997 21.0804L14.8264 17.0538C15.1997 16.6804 15.6931 16.4937 16.1864 16.4937C16.6797 16.4937 17.1731 16.6804 17.5464 17.0538L21.5597 21.0671C22.0664 21.5737 22.7597 21.8671 23.4931 21.8671H25.1731L28.1731 18.8538C28.9253 18.0902 29.3447 17.06 29.3397 15.9882C29.3347 14.9165 28.9057 13.8902 28.1464 13.1338Z",
    fill: "#37B4AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.43ab9e9587448658272f2204acf74cb6.svg";
export { ForwardRef as ReactComponent };